import CustomButton from "common/components/Button/Button"
import "./style.scss"

const ActionToast = ({
  show,
  onHide,
  onConfirm,
  content,
  customButtons,
  buttonLabel,
}: $TSMigrationFixMe) => {
  return show ? (
    <div
      className='tw-shadow-2xl tw-fixed tw-bottom-0 md:tw-bottom-4 tw-left-1/2 -tw-translate-x-1/2 tw-bg-white tw-opacity-100 tw-z-100 tw-w-full md:tw-w-[800px]'
      style={{ zIndex: 1201 }}
    >
      <div>
        <div
          role='alert'
          aria-live='assertive'
          aria-atomic='true'
        >
          <div className='tw-items-center tw-w-full tw-px-4 tw-pb-4 tw-pt-0 md:tw-pt-4 md:tw-flex md:tw-flex-row'>
            <div className='tw-flex tw-flex-col md:tw-flex-row md:tw-px-4 tw-items-center tw-w-full'>
              <div className='tw-w-full tw-h-full tw-px-2 tw-py-4'>
                {content}
              </div>
              <div className='tw-items-center tw-flex md:tw-justify-end tw-gap-8 tw-cursor-pointer tw-w-full md:tw-w-auto tw-py-4'>
                {customButtons || (
                  <CustomButton
                    type='submit'
                    className='!tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none tw-cursor-pointer tw-w-full md:tw-w-auto'
                    onClick={onConfirm}
                  >
                    {buttonLabel}
                  </CustomButton>
                )}
              </div>
            </div>
            <button
              type='button'
              className='tw-text-neutral-75 tw-w-8 tw-hidden md:tw-flex tw-items-center'
              onClick={onHide}
            >
              <span className='pi pi-times' />
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null
}

export default ActionToast
